export default "__VITE_ASSET__BRNoiBJK__"